import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07e5c1ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center ml-2" }, null, -1))
const _hoisted_2 = { class: "auth-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_auth = _resolveComponent("auth")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_SessionsViewer = _resolveComponent("SessionsViewer")!
  const _component_TriagedReport = _resolveComponent("TriagedReport")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "primary",
        position: "fixed"
      }, {
        default: _withCtx(() => [
          (_ctx.isAuthed)
            ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.drawer = !_ctx.drawer), ["stop"]))
              }))
            : _createCommentVNode("", true),
          _hoisted_1,
          _createVNode(_component_v_app_bar_title, { "data-testId": "ap-toolbar-title" }, {
            default: _withCtx(() => [
              _createTextVNode("Intellitask Admin Dashboard")
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          (_ctx.isAuthed)
            ? (_openBlock(), _createBlock(_component_v_select, {
                key: 1,
                items: _ctx.environmentsList,
                label: "Environment",
                modelValue: _ctx.environment,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.environment) = $event)),
                  _cache[2] || (_cache[2] = ($event: any) => ($options.updateEnvironment()))
                ],
                class: "application-select-box"
              }, null, 8, ["items", "modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.isAuthed)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 2,
                variant: "text",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.signOut()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Sign out")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.isAuthed)
        ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
            key: 0,
            position: "fixed",
            modelValue: _ctx.drawer,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.drawer) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    link: "",
                    class: _normalizeClass({ 'active-item': _ctx.selectedTab === 'sessions-viewer' }),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedTab = 'sessions-viewer'))
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-weather-night" })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Sessions Viewer")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_list_item, {
                    link: "",
                    class: _normalizeClass({ 'active-item': _ctx.selectedTab === 'triage-report' }),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedTab = 'triage-report'))
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-menu" })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Triage Report")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, { class: "bg-light-grey" }, {
        default: _withCtx(() => [
          (!_ctx.isAuthed)
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 0,
                "justify-center": "",
                "align-center": "",
                "vertical-align-center": ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_auth, {
                      onAuth: $options.loginComplete,
                      onError: $options.handleError
                    }, null, 8, ["onAuth", "onError"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isAuthed)
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 1,
                class: "px-0"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_SessionsViewer, { ref: "sessionsViewer" }, null, 512), [
                    [_vShow, _ctx.selectedTab == 'sessions-viewer' && _ctx.isAuthed]
                  ]),
                  _withDirectives(_createVNode(_component_TriagedReport, { ref: "triageReport" }, null, 512), [
                    [_vShow, _ctx.selectedTab == 'triage-report' && _ctx.isAuthed]
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_snackbar, {
        modelValue: $options.hasError,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($options.hasError) = $event)),
        color: "secondary",
        class: "gray--text",
        location: "top",
        timeout: 5,
        "multi-line": true
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.errorMessage) + " ", 1),
          _createVNode(_component_v_btn, {
            variant: "text",
            color: "accent",
            class: "mr-2",
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.dismissError()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Dismiss")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}